export default {"src":"/_next/static/media/2d.fc88a67a.gif","height":600,"width":1000,"blurWidth":0,"blurHeight":0};